export const getHttpCode = (state) => {
  return state?.errorHandler?.httpCode;
};

export const getHttpMessage = (state) => {
  return state?.errorHandler?.httpMessage;
};